import styled from 'styled-components'
import { rem } from 'polished'

import LoadingBox from 'components/Common/Loading/LoadingBox'

const Tile = styled(LoadingBox)`
  flex-shrink: 0;
  inline-size: ${rem(180)};
  block-size: ${rem(112)};
`

function ExperiencesHomepageBrowseTileSkeleton() {
  return (
    <Tile
      borderRadius="M"
      data-testid="browse-trend-tile-skeleton"
    />
  )
}

export default ExperiencesHomepageBrowseTileSkeleton
